import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { arrayToCsv, downloadCsv } from "../../../Utils/Utils";
import rest from 'rest';
import { REST_API_URL} from "../../../Utils/Global";
/**
* Class ExportCSV
* Generic component to generate status bar
**/
class ExportView extends Component {
  /**
  * props
  * parent : parent component
  **/

  /**
  * render
  * Rendering component function : display the status bar
  **/
  render() {
    return (
      <div className="btnExportGrid">
        <Button bsStyle="primary" onClick={this.props.customFn instanceof Function ? this.props.customFn : this.export.bind(this)}>Exporter</Button>
      </div>
    )
  }

  /**
  * export
  * Export clients as CSV
  **/
  export() {
    if(!this.props.parent) return;

    let requete =this.props.parent.state.requete;
    console.log(requete.nomvue);

    let data = [];
    let arrData= [];
    let columnsName = [];


    rest({method: 'GET', path: REST_API_URL + 'view/' + requete.nomvue}).then(response => {
      data = JSON.parse(response.entity);
      rest({method: 'GET', path: REST_API_URL + 'view/fields/' + requete.nomvue}).then(response => {
        columnsName = JSON.parse(response.entity);
        


        arrData.push(columnsName);

        // Fill data
        data.forEach(
          (obj, index) => {
            arrData.push(obj);
          }
        );

        const csv = arrayToCsv(arrData);
        downloadCsv(csv, requete.nom);

      });

    });






  }

}

export default ExportView;



// WEBPACK FOOTER //
// ./src/views/Helper/Grid/ExportView.js